<template>
  <div class="notice-mask" v-if="showNotice && props.noticeInfos?.length">
    <div class="notice-container">
      <div class="notice-close" @click="onClose">x</div>
      <div class="notice-contnet">
        <div class="version-info">
          <span>更新版本：{{ props.noticeInfos[0] }}</span>
          <span class="ml50">更新时间：{{ props.noticeInfos[1] }}</span>
        </div>
        <div class="update-info">
          <div class="update-title">更新内容</div>
          <div class="update-content">
            <div class="mb5" v-for="(item, index) in props.noticeInfos.slice(2, props.noticeInfos.length)" :key="index">
              {{ index + 1 }}、{{ item }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { useUserStore } from "@/store";
import { onMounted, ref, watch } from "vue";
const props = defineProps({
  noticeInfos: {
    type: Array,
    defulat: [],
  },
});
const userStore = useUserStore();
const showNotice = ref(false);
watch(
  () => userStore.userInfo.isNewVersion,
  (newValue) => {
    showNotice.value = newValue === false;
  }
);
const onClose = () => {
  userStore.userInfo.isNewVersion = true;
};
onMounted(()=>{
  showNotice.value = userStore.userInfo.isNewVersion === false;
  console.log(props.noticeInfos,'props.noticeInfos')
})
</script>
